import { PROJECT_WORKSPACE_NODE_HEIGHT } from './projectDagNodeDimensions';

const GAP = 40;
const CELL = 200;

const bounds = (node, position = node.position) => ({
  left: position.x, top: position.y,
  right: position.x + (node.measured?.width || node.data?.node?.width || 154),
  bottom: position.y + (node.measured?.height || node.data?.node?.height
    || (node.id === 'center' ? PROJECT_WORKSPACE_NODE_HEIGHT : 150)),
});

// Place additions only. A spatial grid avoids rescanning the graph for every
// candidate; jumping past blockers also handles dense manually arranged graphs.
export const placeNewProjectDagNodes = (nodes, fixedKeys) => {
  if (!fixedKeys.size || nodes.every((node) => fixedKeys.has(node.id))) return nodes;
  const cells = new Map();
  const visitCells = (box, visit) => {
    for (let x = Math.floor((box.left - GAP) / CELL); x <= Math.floor((box.right + GAP) / CELL); x += 1) {
      for (let y = Math.floor((box.top - GAP) / CELL); y <= Math.floor((box.bottom + GAP) / CELL); y += 1) visit(`${x}:${y}`);
    }
  };
  const reserve = (box) => visitCells(box, (key) => {
    if (!cells.has(key)) cells.set(key, []);
    cells.get(key).push(box);
  });
  nodes.forEach((node) => { if (fixedKeys.has(node.id)) reserve(bounds(node)); });
  return nodes.map((node) => {
    if (fixedKeys.has(node.id)) return node;
    let position = node.position;
    let box = bounds(node, position);
    // Each jump clears at least one existing bottom edge; at most N are needed.
    for (let attempt = 0; attempt <= nodes.length; attempt += 1) {
      let nextY = position.y;
      const candidate = box;
      visitCells(candidate, (key) => (cells.get(key) || []).forEach((other) => {
        if (candidate.left < other.right + GAP && candidate.right + GAP > other.left
          && candidate.top < other.bottom + GAP && candidate.bottom + GAP > other.top) {
          nextY = Math.max(nextY, other.bottom + GAP);
        }
      }));
      if (nextY === position.y) break;
      position = { ...position, y: nextY };
      box = bounds(node, position);
    }
    reserve(box);
    return position === node.position ? node : { ...node, position };
  });
};

